module.exports = __webpack_public_path__ + "img/makinormalmithintergrundfrontal.e41e554a.jpg";